/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function variantselectionBoxes() {
  var productSelectors = $('.optionPickers').find('select');


  for (let i = 0; i < productSelectors.length; ++i) {
    var variantOptions = $('#ProductSelect-option-' + [i] + '')
    var selectorWrapper = $('#ProductSelect-option-' + [i] + '').parent('.selector-wrapper');

    if (variantOptions.length > 0) {
      for (let j = 0; j < variantOptions[0].length; j++) {
        let optionName = variantOptions[0][j].value;
        $(selectorWrapper).append('<div value="' + optionName + '">' + optionName + '</div>').addClass('selectBox');
      }
    }

  }
}

function inititalSelection(){
  variant_id = new URL(window.location.href).searchParams.get('variant');
  for(variant of productJson.variants){
  	if(variant.id == variant_id){
      console.log(variant.title);
      var searchProductLength = variant.options[0];
      var searchProductColor = variant.options[1];
      var searchWireGauge = variant.options[2];
      var imageID = variant;
    }  
  }
  
  //Initial Length Selection
  $('.optionPickers').find('div[value="'+ searchProductLength + '"]').addClass('active').siblings().removeClass('active');
   $('#ProductSelect-option-0').val(searchProductLength).change();
  
  //Initial Color Selection
  $('.optionPickers').find('div[value="'+ searchProductColor + '"]').addClass('active').siblings().removeClass('active')
  $('#ProductSelect-option-1').val(searchProductColor).change();
  
  //Initial Wire Gauge Selection
  $('.optionPickers').find('div[value="'+ searchWireGauge + '"]').addClass('active').siblings().removeClass('active')
  $('#ProductSelect-option-2').val(searchWireGauge).change();

  var variantObject = {};
  const thumbnailDataAttributes = $('.product-gallery__thumbnail').map(function() {
    return $(this)[0].attributes[3].value;
  }).get();

  const colorsArray = $("#ProductSelect-option-1 > option").map(function() {
    return $(this)[0].value;
  }).get();

  colorsArray.forEach((element, index) => {
    variantObject[element] = thumbnailDataAttributes[index];
  });

  var imageID = variantObject[searchProductColor];
  
  // //Initial Carousel Image Selection
  $('.product-gallery__thumbnail[data-media-id="' + imageID +'"]').addClass('is-nav-selected').siblings().removeClass('is-nav-selected');
  $('.product-gallery__carousel-item[data-media-id="' + imageID +'"]').addClass('is-selected').siblings().removeClass('is-selected');

}



function customOptionsBoxes() {
  var selectionsWrapper = $('.selector-wrapper.selectBox');
  var optionBox = $('.selector-wrapper.selectBox div');
  
  $(optionBox).click(function() {
    var currentOptionText = $(this)[0].textContent;
    if (!$(this).hasClass('active')) {
      $(this).addClass('active');
      $(this).siblings().removeClass('active');
  	  $(this).parent('.selector-wrapper').find('.currentOptionValue').text(currentOptionText);
    }
    
  });
  
}


function changeVariantSelectors() {
	
  var variantBoxSelector = $('.selector-wrapper.selectBox div');

    $(variantBoxSelector).click(function(){
      if($(this).hasClass('active')){
        var optionValue = $(this).attr('value');
        $(this).siblings('.single-option-selector').val(optionValue).change()

       }

    });
}

function imageSelection(){

  		var optionsVariantValue = $('#ProductSelect')[0].value;
        var selectedColorOption = $('#ProductSelect option[value=' + optionsVariantValue + ']')[0].form[3].value;

        var variantObject = {};
  		var imageObject = {};

        const colorsArray = $("#ProductSelect-option-1 > option").map(function() {
          return $(this)[0].value;
        }).get();

        const thumbnailDataAttributes = $('.product-gallery__thumbnail').map(function() {
          return $(this)[0].attributes[3].value;
        }).get();

        colorsArray.forEach((element, index) => {
          variantObject[element] = thumbnailDataAttributes[index];
        });
  
  		thumbnailDataAttributes.forEach((element, index) => {
          imageObject[element] = colorsArray[index];
        });
        
  		const colorOption = $('#ProductSelect-option-1').siblings('div');
  		const imageOption = $('.product-gallery__thumbnail')
          

            $(colorOption).on('click change keyup keydown' , function(){

              const colorValue = $(this)[0].attributes[0].value;
              console.log(colorValue);
              var imageID = variantObject[colorValue];
              $('.product-gallery__thumbnail[data-media-id="' + imageID +'"]').addClass('is-nav-selected').siblings().removeClass('is-nav-selected');
              $('.product-gallery__carousel-item[data-media-id="' + imageID +'"]').addClass('is-selected').siblings().removeClass('is-selected');

            });
  
  
           $(imageOption).click(function(){
          	
              const imageValue = $(this)[0].attributes[3].value;
              var swatchID = imageObject[imageValue];
             	
//               console.log(swatchID);
            	$('.selector-wrapper div[value="' + swatchID +'"]').addClass('active').siblings().removeClass('active');
             	$('#ProductSelect-option-1').val(swatchID).change();
            	$('.flickity-slider').find('.product-gallery__carousel-item[data-media-id="' + imageValue + '"]').addClass('is-selected').siblings().removeClass('is-selected')
        	});
  
  			

}

function colorSwatchStyling() {
	
   const colorSwatchDivs = $('#ProductSelect-option-1').siblings('div');
	
  for(let i=0; i < colorSwatchDivs.length; i++){
  	
    var currentSwatch = colorSwatchDivs[i];
    var markerAttribute = i;
    $(currentSwatch).css('background-color', $(currentSwatch).attr('value')).css('color', $(currentSwatch).attr('value')).css('font-size', '0').css('height','36px').css('width','36px').css('flex-basis','unset').attr('marker', markerAttribute);
 
  }
}

$(document).ready (function() {	
 variantselectionBoxes();
 colorSwatchStyling()
customOptionsBoxes();
changeVariantSelectors();
 imageSelection();
 inititalSelection();
 console.log("asdf");
  $('#input-id').on('change keyup keydown', function() {
     $.post('/cart.js', {
     attributes: {
        'Cart Attribute Name': $(this).val()
     }
    }).done(function() {
   });
   });
 });
 $('.additional-details input').on('change keyup keydown', function() {
      console.log("FFG",$(this).parent().find("label").text())
     var attributename=$(this).parent().find("label").text();
    $.post('/cart.js', {
      attributes: {
   [attributename] : $(this).val()
      }
   }).done(function() {
    });
  });
 